/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getCustomerHoldingsCurrentMarketValue} from '../api'

 export const useQueryGetCustomerHoldingsCurrentMarketValue = createReactQueryHook('getCustomerHoldingsCurrentMarketValue', getCustomerHoldingsCurrentMarketValue)
